// extracted by mini-css-extract-plugin
module.exports = {"withdrawBtn":"WithdrawButton_withdrawBtn__mAPp9","disabled":"WithdrawButton_disabled__1s6g6","submitBtnBox":"WithdrawButton_submitBtnBox__dWMbu"};